import type {
  FeatureCatalogoItemOutputType,
  FeatureToggleInputType,
  SysAdminCreateInputType,
  SysAdminLoginInputType,
  SysAdminLoginOutputType,
  SysAdminOutputType,
  TenantCreateInputType,
  TenantOutputType,
  TenantUpdateInputType,
} from '../../../shared/dto';
import { callApi } from './call-api';

export const sysAdminApi = {
  login: (body: SysAdminLoginInputType) =>
    callApi<SysAdminLoginOutputType>({
      method: 'POST',
      path: '/sys-admin/login',
      body,
    }),

  logout: (_args: void) =>
    callApi<void>({
      method: 'POST',
      path: '/sys-admin/logout',
    }),

  me: (_args: void) =>
    callApi<SysAdminOutputType>({
      path: '/sys-admin/me',
    }),

  listarUsuarios: (_args: void) =>
    callApi<SysAdminOutputType[]>({
      path: '/sys-admin/usuarios',
    }),

  criarUsuario: (body: SysAdminCreateInputType) =>
    callApi<SysAdminOutputType>({
      method: 'POST',
      path: '/sys-admin/usuarios',
      body,
    }),

  listarTenants: (_args: void) =>
    callApi<TenantOutputType[]>({
      path: '/sys-admin/tenants',
    }),

  criarTenant: (body: TenantCreateInputType) =>
    callApi<TenantOutputType>({
      method: 'POST',
      path: '/sys-admin/tenants',
      body,
    }),

  atualizarTenant: ({ id, dados }: { id: string; dados: TenantUpdateInputType }) =>
    callApi<TenantOutputType>({
      method: 'PUT',
      path: `/sys-admin/tenants/${id}`,
      body: dados,
    }),

  listarFeatures: (_args: void) =>
    callApi<FeatureCatalogoItemOutputType[]>({
      path: '/sys-admin/features',
    }),

  alternarFeature: ({
    tenantId,
    key,
    dados,
  }: {
    tenantId: string;
    key: string;
    dados: FeatureToggleInputType;
  }) =>
    callApi<TenantOutputType>({
      method: 'PUT',
      path: `/sys-admin/tenants/${tenantId}/features/${encodeURIComponent(key)}`,
      body: dados,
    }),
};
